import React, { useEffect } from 'react';
import { autoUpdate, offset, shift, useFloating } from '@floating-ui/react';
import EditHotspot from './EditHotspot.jsx';

function FloatingEditHotspot({
  referenceElement,
  placement = 'bottom-end',
  offsetPx = -8,
  size = 26,
  iconSize = 12,
  ringDuration,
  className,
  style,
  label = 'Tap to edit',
  onClick,
}) {
  const { refs, floatingStyles, update } = useFloating({
    placement,
    strategy: 'fixed',
    middleware: [offset(offsetPx), shift({ padding: 8 })],
    whileElementsMounted: autoUpdate,
  });

  useEffect(() => {
    refs.setReference(referenceElement || null);
  }, [referenceElement, refs]);

  useEffect(() => {
    if (referenceElement) {
      update?.();
    }
  }, [referenceElement, update, size, iconSize]);

  if (!referenceElement) {
    return null;
  }

  const isInteractive = typeof onClick === 'function';

  return (
    isInteractive ? (
      <button
        ref={refs.setFloating}
        type="button"
        onClick={onClick}
        style={{ ...floatingStyles, zIndex: 30, pointerEvents: 'auto', background: 'transparent', border: 0, padding: 0 }}
        aria-label={label}
      >
        <EditHotspot
          size={size}
          iconSize={iconSize}
          ringDuration={ringDuration}
          className={className}
          style={style}
          label={label}
        />
      </button>
    ) : (
      <div
        ref={refs.setFloating}
        style={{ ...floatingStyles, zIndex: 30, pointerEvents: 'none' }}
        aria-hidden="true"
      >
        <EditHotspot
          size={size}
          iconSize={iconSize}
          ringDuration={ringDuration}
          className={className}
          style={style}
          label={label}
        />
      </div>
    )
  );
}

export default FloatingEditHotspot;